export default __webpack_public_path__ + "static/media/12-3.92ff4705.png";